module.exports = __webpack_public_path__ + "static/media/fail.b5863872.jpg";